import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiLoader, FiX } = FiIcons;

export default function ReconciliationDeleteWarning({
  reconciliation,
  isDeleting,
  onCancel,
  onConfirm
}) {
  if (!reconciliation) return null;

  const isUnbalanced = reconciliation.status === 'UNBALANCED';
  const title = isUnbalanced
    ? 'If you delete this review, you’ll need to start reconciliation again'
    : 'If you delete this period, you’ll need to reconcile your books again';
  const description = isUnbalanced
    ? 'This unfinished reconciliation will be removed from your active history. No transactions have been matched yet.'
    : 'All transactions will be unmatched and you’ll need to match everything again.';

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-900/45 p-4 backdrop-blur-sm">
      <div
        className="relative w-full max-w-[800px] overflow-hidden rounded-2xl bg-white px-6 py-10 text-center shadow-2xl sm:px-12"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reconciliation-delete-title"
      >
        <button
          type="button"
          onClick={onCancel}
          disabled={isDeleting}
          className="absolute right-5 top-5 rounded-lg p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 disabled:cursor-not-allowed"
          aria-label="Close delete warning"
        >
          <SafeIcon icon={FiX} className="text-2xl" />
        </button>

        <div className="mx-auto mb-7 flex h-24 w-24 items-center justify-center rounded-[28px] border-4 border-rose-100 bg-rose-50 text-rose-500 shadow-inner">
          <SafeIcon icon={FiAlertTriangle} className="text-5xl" />
        </div>

        <h2
          id="reconciliation-delete-title"
          className="mx-auto max-w-2xl text-3xl font-black leading-tight tracking-tight text-slate-900 sm:text-4xl"
        >
          {title}
        </h2>

        <p className="mx-auto mt-5 max-w-xl text-lg font-medium leading-relaxed text-slate-600">
          {description}
        </p>

        <div className="mt-9 flex flex-col-reverse justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="rounded-full border border-blue-600 px-8 py-3 text-base font-black text-blue-700 transition-colors hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-rose-600 px-9 py-3 text-base font-black text-white transition-colors hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isDeleting && <SafeIcon icon={FiLoader} className="animate-spin" />}
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}